import { render } from "./ContactAuthFormSugest.vue?vue&type=template&id=0ba83186"
import script from "./ContactAuthFormSugest.vue?vue&type=script&lang=js"
export * from "./ContactAuthFormSugest.vue?vue&type=script&lang=js"
script.render = render

export default script